import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ConfigService } from '@services/config/config.service';
import {AvlTraceComponentDefinition} from './avl-trace.component.definition';
import {FormbirdInjectorService, SearchService} from 'formbird-services';
import {SclUtilAvlService, SclUtilGmapService} from 'formbird-sc-shared';
import {SclMapConstantService} from '../../../../formbird-mapping/src/lib/scl-map-constant.service';
import {SclUtilMapService} from '../../../../formbird-mapping/src/lib/scl-util-map.service';
import * as c3 from 'c3';
import LayerVector from 'ol/layer/Vector';
import SourceVector from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import * as proj from 'ol/proj';
// import * as $ from 'jquery';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import {ChangedDocumentService} from 'formbird-services';

// import { AvlTestData } from './avl-test-data';

@Component({
  templateUrl: './avl-trace.component.html',
  styleUrls: [
    './avl-trace.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvlTraceComponent extends AbstractComponent<AvlTraceComponentDefinition> implements OnInit, AfterViewInit {

  @ViewChild('targetMap', {static: false}) target: ElementRef;
  @ViewChild('container', {static: false}) container: ElementRef;
  @ViewChild('content', {static: false}) content: ElementRef;
  @ViewChild('containerChart', {static: false}) containerChart: ElementRef;
  @ViewChild('tooltipInfo', {static: false}) tooltipInfo: ElementRef;

  // services
  notificationService: any;
  dataService: any;
  loggedInUserService: any;

  //
  view;
  sourceVector;
  vectorLayer;
  overlay;
  timeOld = '';
  graphPoint;
  EPSG_3857 = 'EPSG:3857';
  EPSG_4326 = 'EPSG:4326';
  disableMouseWheel = false;
  vehicle;
  preSize;
  vehicleData;
  vehicleIconFileField;
  timeFormat = 'hh:mm a';
  olMap;
  displayArrorHeads = false;
  imei = '';
  showimei = true;
  dt;
  firstTime = true;
  isOpening;
  chart;
  dateOffSet;
  numOffSet;
  previousData;
  infoPosition = {left: '0px', top: '0px'};
  mapCenter;
  tooltipPosition;
  mouseX = 0;
  mouseY = 0;
  isPopoverOpen = false;
  stopLoop;
  mouseStopInterval;
  lastEvt = null;
  isInitVehiclesField = true; // = true for angular version because related-document not fire when first time load component
  mapHeight;
  apiKey;

  constructor(
    public cdRef: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected formbirdInjectorService: FormbirdInjectorService,
    private sclUtilGmapService: SclUtilGmapService,
    private sclUtilMapService: SclUtilMapService,
    private sclUtilAvlService: SclUtilAvlService,
    private configService: ConfigService,
    private httpClient: HttpClient,
    private searchService: SearchService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);

    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.dataService = this.formbirdInjectorService.get('DataService');
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
  }

  ngOnInit() {
    this.apiKey = 'AIzaSyDr8ovTk9O_JVvCokeaFE6nzsbhMRBCQm8'; // avl-dev server
    // this.apiKey = 'AIzaSyDLF3KfOk7figOYUQAudATOTTqCbzf1ylc'; // localhost:3000

    this.componentSetupService.setupStandardProperties(this);

    if (!(typeof this.componentDefinition.vehicleIconFileField === 'undefined' || this.componentDefinition.vehicleIconFileField === null)) {
      this.vehicleIconFileField = this.componentDefinition.vehicleIconFileField;
    }
    if (!(typeof this.componentDefinition.disableMouseWheel === 'undefined' || this.componentDefinition.disableMouseWheel === null)) {
      this.disableMouseWheel = this.componentDefinition.disableMouseWheel;
    }
    if (!(typeof this.componentDefinition.displayArrorHeads === 'undefined' || this.componentDefinition.displayArrorHeads === null)) {
      this.displayArrorHeads = this.componentDefinition.displayArrorHeads;
    }

    const clientConfig = this.configService.clientConfig();
    if (clientConfig) {
      if (clientConfig.dateFormat && clientConfig.dateFormat.time) {
        this.timeFormat = clientConfig.dateFormat.time;
      }
      if (clientConfig.avlTimeOld) {
        this.timeOld = clientConfig.avlTimeOld;
      }
    }
    console.log('AVL time old is ' + this.timeOld);

    this.dateOffSet = new Date();
    this.numOffSet = this.dateOffSet.getTimezoneOffset() / 60;

    if (typeof this.componentDefinition.heightNum === 'undefined' || this.componentDefinition.heightNum === null) {
      this.mapHeight = '180';
    } else {
      let height = 180 * this.componentDefinition.heightNum;
      const docHeight = document.body.scrollHeight;
      if (height > (docHeight - 180)) {
        height = docHeight - 180;
      }
      this.mapHeight = '' + height;
    }

    this.setupChangeDetection();
  }


  ngAfterViewInit() {
    // map
    this.loadMap();

    const dateTimeFieldSub = this.changedDocumentService.watch(this.componentDefinition.dateTimeField
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch dateTimeField, value = ' + fieldValue);
        this.document[this.componentDefinition.dateTimeField] = fieldValue;
        this.watchDateTimeField(fieldValue);
    });
    this.subs.add(dateTimeFieldSub);
  }

  loadMap() {
    console.log('loadMap');
    this.view = this.sclUtilMapService.setView(undefined, undefined, undefined, undefined, undefined, undefined);
    this.olMap = this.sclUtilMapService.initializeMapDefault([], this.target.nativeElement
      , this.view, [], this.disableMouseWheel, null, null);
    this.overlay = this.sclUtilMapService.createOverlay(this.container.nativeElement);
    this.overlay.setMap(this.olMap);
    this.sourceVector = new SourceVector();
    this.vectorLayer = new LayerVector({
      source: this.sourceVector,
      style: this.sclUtilMapService.styleFunction
    });
    this.olMap.addLayer(this.vectorLayer);
    this.olMap.once('postrender', (event) => {
      this.preSize = this.olMap.getSize();
    });
    // change mouse cursor when over marker
    $(this.olMap.getViewport()).on('mousemove', (e) => {
      const pixel = this.olMap.getEventPixel(e.originalEvent);
      const hit = this.olMap.forEachFeatureAtPixel(pixel, (feature, layer) => {
          return feature;
      });
      if (hit) {
        this.olMap.getViewport().style.cursor = 'pointer';
      } else {
        this.olMap.getViewport().style.cursor = '';
      }
    });
    this.olMap.on('change:size', (event) => {
      const newSize = event.target.getSize();
      console.log('change:size' + newSize);
      if (this.previousData && newSize[0] !== this.preSize[0]) {
        console.log('Reload map');
        this.previousData = newSize;
        this.showMap(this.previousData);
      }
    });
    this.olMap.on('click', (evt) => {
      this.overlay.setPosition(undefined);
    });
    this.olMap.on('pointermove', (evt) => {
      if (evt.dragging) {
        return;
      }

      this.lastEvt = evt;

      if (!this.mouseStopInterval) {
        this.mouseStopInterval = setInterval( () => {
            this.hasMouseStopped(evt);
          }, 250);
      }
    });
    this.olMap.on('click', (evt) => {
      const feature = this.displayFeatureInfo(evt.pixel);
      if (feature && feature.getProperties().url) {
        window.location.href = feature.getProperties().url;
      }
    });
  }

  watchDateTimeField(newVal) {
    if (newVal == null) { newVal = new Date(); }
    console.log('value = ' + newVal);
    this.dt = newVal;
    this.changeDt();
  }

  changeDt() {
    console.log('changeDt, scope.dt = ' + this.dt);
    this.clearMap();
    if (this.graphPoint) {
      this.graphPoint = null;
    }
    this.olMap.getOverlays().clear();


    this.vehicle = this.document[this.componentDefinition.avlVehiclesField];
    if (this.vehicle && this.vehicle.length > 0 && this.vehicle[0].documentId) {
      if (this.firstTime) {
        console.log('in here 11111');
        const params = {
          functionName: 'getLastEvent',
          componentDocumentName: 'sc-avl-trace-web-component',
          functionParameters: [this.componentDefinition.dataService, this.vehicle[0].documentId]
        };
        this.httpClient.post('api/execute', params).subscribe( (dataResult: any) => {
          console.log('apiGetLastEvent , result data = ');
          console.log(dataResult);
          const data = dataResult; // dataResult is array
          if (data && data.length > 0) {
            console.log('getVehicleData: ' + this.vehicle[0].documentId);
            const options = this.sclUtilMapService.constructQueryDocument([this.vehicle[0].documentId], this.document);
            console.log('options = ' + JSON.stringify(options) );
            // apiGetVehicleData(documentId)
            this.searchService.search(options)
                .then( (results) => {
                  // results = AvlTestData.vehicleData; // test test
                  console.log('changeDt, searchService result = ', results);
                  if (results && results.data && results.data.hits && results.data.hits.hits && results.data.hits.hits.length > 0) {
                    const itemData = results.data.hits.hits[0]._source;
                    if (!itemData) { return; }
                    this.vehicleData = itemData;
                  } else {
                    console.error('Something wrong, can not get vehicle info with documentId: ');
                  }
                  const currentDate = new Date(data[0].eventDate);
                  // this will trigger scope.watch('dt') and this function get called again, this time got to else, not here
                  this.dt = currentDate;
                  this.document[this.componentDefinition.dateTimeField] = currentDate;

                  this.cdRef.detectChanges();

                }, (err) => {
                  console.error('error options when getting vehicles data :' + options.filter);
                  console.error(err);
                }
            );
          } else {
            this.clearMap();
            if (this.chart) {
              this.chart.unload();
            }
            this.notificationService.printMessage('No event found');
          }
        }, (err) => {
          console.error('error query current location :');
          console.error(err);
        });
      } else {
        console.log('in here 22222');
        const currentDate = new Date(this.dt);
        this.searchEvent(currentDate);
      }
      this.firstTime = false;
    }
  }
  // request to get events
  searchEvent(selectedDate) {
    console.log('Searching event for date: ' + selectedDate);
    const format = 'YYYY-MM-DD';


    let startDate = new Date(selectedDate);
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(1);

    startDate = new Date(startDate.getTime());
    console.log('Offset Time: ' + startDate.getTimezoneOffset()
     + '\tstartDate.getTime(): ' + startDate.getTime() + '\tTestDate: ' + startDate);

    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 1);

    const startDateFormat = startDate.toISOString();
    const endDateFormat = endDate.toISOString();

    const params = {
      functionName: 'getAvlEvent',
      componentDocumentName: 'sc-avl-trace-web-component',
      functionParameters: [this.componentDefinition.dataService, this.vehicle[0].documentId, startDateFormat, endDateFormat]
    };

    console.log('calculated start date: ' + startDateFormat + '\tcalculated end date: ' + endDateFormat);
    // getAvlEvent
    this.httpClient.post('api/execute', params).subscribe( (res: any) => {
      // res = AvlTestData.points; // test test
      console.log('searchEvent , res = ', res);
      const customData = res; // res is array

      const dataes = [];
      if (customData) {

        console.log('Event number is ' + customData.length);


        if (customData.length === 0) {
          this.notificationService.printMessage('No event found this date');
        } else {
          console.log('first event:\n' + JSON.stringify(customData[0]));
        }

        if (customData.length > 2) {
            console.log('true start date: ' + customData[0].eventDate);
            console.log('true end date: ' + customData[customData.length - 1].eventDate);
        }


        for (let i = 0; i < customData.length; i++) {
          const valJson = customData[i];

          const object = this.sclUtilMapService.parseAVLData_New(valJson);

          const icon = this.sclUtilMapService.checkAVLSpeed(SclMapConstantService.AVL_SPEED_BEGINNING,
              parseFloat(object.speedKPH).toFixed(5),
              parseFloat(object.heading),
              parseFloat(this.vehicleData.imeiSpeedA),
              parseFloat(this.vehicleData.imeiSpeedB),
              parseFloat(this.vehicleData.imeiSpeedC),
              parseFloat(this.vehicleData.imeiSpeedD),
              parseFloat(this.vehicleData.imeiSpeedE)
          );
          object.icon = icon;

          dataes.push(object);
        }
        this.showMap(dataes);
      }
    }, (err) => {
      console.log('Error: ', err);
    });
  }

  convertGPSToAddress(coor, cb) {
    const lat = parseFloat(coor[1]);
    const lon = parseFloat(coor[0]);

    const link = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&key=' + this.apiKey;
    this.httpClient.get(link).subscribe((data: any) => {
        if (data.status === 'OK' ) {
          if (cb && typeof cb === 'function') {
            cb(data);
          }
        } else {
          console.log('Error: ' + data.error_message);
          cb(null);
        }
    }, error => {
      console.log('Error : ' + error);
      cb(null);
    });
  }

  showVehicle(location, heading, text) {
    if (this.graphPoint) {
      this.sourceVector.removeFeature(this.graphPoint);
    }

    this.graphPoint = new Feature(new Point(location));

    let icon = SclMapConstantService.MAP_MARKER_CROSS_GREEN;

    if (this.vehicleData && this.vehicleIconFileField && this.vehicleData[this.vehicleIconFileField]
      && Array.isArray(this.vehicleData[this.vehicleIconFileField]) && this.vehicleData[this.vehicleIconFileField].length > 0 ) {
        const imageData = this.vehicleData[this.vehicleIconFileField][0];
        icon = '/api/getFile/' + imageData.fileNo + '/' + imageData.fileName;
    }

    const iconStyle = {
      src: icon,
      rotation: Math.PI * heading / 180.0
    };

    this.graphPoint.setStyle(new Style({
      image: new Icon(iconStyle),
      zIndex: 0
    }));

    if (text) {
      this.content.nativeElement.innerHTML = '<div>' + text + '</div>';
      this.overlay.setPosition(location);
    } else {
      this.overlay.setPosition(undefined);
    }

    this.sourceVector.addFeature(this.graphPoint);
    this.view.setCenter(location);
  }

  clearMap() {
    if (this.sourceVector) {
      this.sourceVector.clear();
    }
  }

  // show data
  showMap(data) {

    if (data.length === 0) {
      this.clearMap();
      if (this.chart) {
        this.chart.unload();
      }
      return;
    }
    this.previousData = data;

    let currentLat = 0;
    let currentLon = 0;
    let nextLat = 0;
    let nextLon = 0;

    const self = this;
    const listCoordinate = [];
    for (let i = 0; i < data.length - 1 ; i++) {
      currentLat = parseFloat(data[i].latitude);
      currentLon = parseFloat(data[i].longitude);
      // the line is stored in the index one above the point, so read the line in the next item after the point
      const lineIndex = i + 1;
      // read the values using the lineIndex
      nextLat = parseFloat(data[lineIndex].latitude);
      nextLon = parseFloat(data[lineIndex].longitude);

      // parse coordinate using the index
      const coor = proj.transform([currentLon, currentLat], 'EPSG:4326', 'EPSG:3857');

      // parse coordinate using the lineIndex
      const coorNext = proj.transform([nextLon, nextLat], 'EPSG:4326', 'EPSG:3857');

      // add point at i index
      const pointFeature1: any = this.sclUtilMapService.parseAVLTracePoint(data[i], this.timeFormat, data[i].imei);
      pointFeature1.latitude = data[i].latitude;
      pointFeature1.longitude = data[i].longitude;

      // parse line from index, index + 1
      const lineFeature = this.sclUtilMapService.parseLineString(coor[0], coor[1], coorNext[0], coorNext[1]);

      this.sourceVector.addFeature(pointFeature1);
      this.sourceVector.addFeature(lineFeature);
    }

    // add last point point.latitude, point.longitude
    const imei = data[data.length - 1].imei;
    const pointFeature = this.sclUtilMapService.parseAVLTracePoint(data[data.length - 1], this.timeFormat, imei);
    this.sourceVector.addFeature(pointFeature);

    this.sclUtilMapService.fit(this.configService, this.sourceVector, this.view, this.olMap, this.componentDefinition.maxZoom);

    const speedData: any = [];
    const events = [];
    const x = [];
    speedData.push('Speed ');
    x.push('x');

    for (let k = 0; k < data.length; k++) {
      const event = data[k];

      const eventDate = new Date(event.eventDate);
      x.push(eventDate.getTime());
      const speed = event.speedKPH;

      if (speed > -1) {
          speedData.push(speed);
      } else {
          speedData.push(0);
      }
      events.push(event);
    }

    const startTime = new Date(data[0].eventDate);
    const endTime = new Date(data[data.length - 1].eventDate);

    const timeValues = [];
    let timeSpaced = 1; // 1 hours

    if (this.preSize && this.preSize.length > 0) {
      if (this.preSize[0] < 400) {
        timeSpaced = 3;
      } else if (this.preSize[0] < 800) {
        timeSpaced = 2;
      }
    }

    const count = Math.round((endTime.getTime() - startTime.getTime()) / 1000 / 60 / 60 / timeSpaced);
    console.log('EndTime: ' + endTime.getHours() + '\tStartTime: ' + startTime.getHours() + '\tcount: ' + count);
    timeValues.push(startTime.getTime());

    for (let k = 1; k < count; ++k) {
      const temp = new Date(startTime);
      temp.setHours(startTime.getHours() + (k * timeSpaced));
      temp.setMinutes(0);
      timeValues.push(temp.getTime());
    }

    timeValues.push(endTime.getTime());

    let previousHoveredPoint;
    let innerClick = false;



    // chart
    this.chart = c3.generate({
        bindto: this.containerChart[0],
        size: {
            height: 200
        },
        data: {
            x: 'x',
            columns: [
                x,
                speedData
            ],
            onclick:  (d, i) => {
              this.olMap.getOverlays().clear();
              console.log('onclick inside');
              console.log(d);
              console.log(i);

              const eve = events[d.index];
              if (!eve) {
                  previousHoveredPoint = undefined;
                  return;
              }

              const lat = eve.latitude;
              const lon = eve.longitude;
              innerClick = true;
              this.onClickGraph([lon, lat], eve.heading);
            },
            onmouseover: (d, element) => {

                const eve = events[d.index];
                if (!eve) {
                    previousHoveredPoint = undefined;
                    return;
                }
                previousHoveredPoint = eve;
                const lat = eve.latitude;
                const lon = eve.longitude;
                const location = proj.transform([lon, lat], this.EPSG_4326, this.EPSG_3857);
                this.showVehicle(location, eve.heading, '');
            }
        },
        axis: {
            x: {
                type: 'timeseries',
                tick: {
                    fit: false,
                    // count: 23,
                    format: '%H:%M',
                    values: timeValues
                }
            }
        },
        zoom: {
            enabled: true

        }
    });

    // event click chart
    this.containerChart.nativeElement.onclick = () => {
        console.log('onclick');
        innerClick = false;
        setTimeout(() => {
            if (!innerClick) {
                if (previousHoveredPoint) {
                    const lat = previousHoveredPoint.latitude;
                    const lon = previousHoveredPoint.longitude;
                    this.onClickGraph([lon, lat], previousHoveredPoint.heading);
                }
            }
        }, 0.015);

    };
  }

  // function clickGraph vs get address
  onClickGraph(location, heading) {
    this.convertGPSToAddress(location, (data) => {
      if (data == null) {
        return;
      }
      console.log('convertGPSToAddress');
      console.log(data);
      const temp = {properties: {}};
      const address = this.sclUtilMapService.fillGoogleAddress(data.data.results[0], temp);
      console.log('address: ');
      console.log(address);
      let text = (address.properties.streetNo) ? address.properties.streetNo : '';
      text += ' ' + ((address.properties.street) ? address.properties.street : '');
      text += '<br> ' + ((address.properties.suburb) ? address.properties.suburb  : '');
      text += '<br> ' + ((address.properties.state) ? address.properties.state : '');
      text += ', ' + ((address.properties.country) ? address.properties.country : '');
      console.log(text);
      this.showVehicle(proj.transform(location, this.EPSG_4326, this.EPSG_3857), heading, text);
    });
  }

  setTooltipPosition(pixel) {
    const featureLeftPos = pixel[0];
    const featureTopPos = pixel[1];

    this.infoPosition.left = featureLeftPos + 'px';
    this.infoPosition.top = featureTopPos + 'px';
    this.isPopoverOpen = true;

    // set the tooltip position
    let tooltipHorizontalPosition;
    let tooltipVerticalPosition;

    if (this.mapCenter == null) {
      this.getMapSize();
    }

    if (featureLeftPos < this.mapCenter.x) {
        tooltipHorizontalPosition = 'left';
    } else {
        tooltipHorizontalPosition = 'right';
    }

    if (featureTopPos < this.mapCenter.y) {
        tooltipVerticalPosition = 'bottom';
    } else {
        tooltipVerticalPosition = 'top';
    }

    this.tooltipPosition = tooltipVerticalPosition + '-' + tooltipHorizontalPosition;
  }

  getMapSize() {
    const mapSize = this.olMap.getSize();

    if (mapSize) {
      const mapWidth = mapSize[0];
      const mapHeight = mapSize[1];
      this.mapCenter = {x: mapWidth / 2, y: mapHeight / 2};
    } else {
      console.log('Couldn\'t get size of map to enable tooltips');
    }
  }

  mapWatchStop() {
    this.getMapSize();
    this.infoPosition = {left: '0px', top: '0px'};
    this.tooltipInfo.nativeElement.innerHTML = '';
    this.tooltipPosition = 'top';
    this.isPopoverOpen = false;
  }
  displayFeatureInfo(pixel) {
    const feature = this.olMap.forEachFeatureAtPixel(pixel, (fea, layer) => {
      return fea;
    });

    if (feature && feature.getProperties().address) {
      if (!feature.addressLoaded) {
          feature.addressLoaded = true;
          const coor = [feature.longitude, feature.latitude];
          this.convertGPSToAddress(coor, (data) => {
              console.log('convertGPSToAddress');
              console.log(data);
              if (data == null) { return; }
              const temp = {properties: {}};
              const address = this.sclUtilMapService.fillGoogleAddress(data.data.results[0], temp);
              let text = (address.properties.streetNo) ? address.properties.streetNo : '';
              text += ' ' + ((address.properties.street) ? address.properties.street : '');
              text += '<br> ' + ((address.properties.suburb) ? address.properties.suburb : '');
              text += '<br> ' + ((address.properties.state) ? address.properties.state : '');
              text += ', ' + ((address.properties.country) ? address.properties.country : '');

              let tooltip = feature.getProperties().address;
              tooltip = tooltip.replace('Address :', 'Address :' + text);
              const propertiesData = {
                  address: tooltip
              };
              feature.setProperties(propertiesData);
              feature.setProperties();
              this.tooltipInfo.nativeElement.innerHTML = feature.getProperties().address;
              this.cdRef.detectChanges();
          });
      }

      this.setTooltipPosition(pixel);

      this.tooltipInfo.nativeElement.innerHTML = feature.getProperties().address;
    } else {
      this.tooltipInfo.nativeElement.innerHTML = '';
    }
    return feature;
  }
  hasMouseStopped(evt) {
    const newMouseX = evt.originalEvent.x;
    const newMouseY = evt.originalEvent.y;

    if ((newMouseX !== this.mouseX) && (newMouseY !== this.mouseY)) {
      this.stopLoop = true;
    } else {
      // stopped moving
      clearInterval(this.mouseStopInterval);
      this.mouseStopInterval = null;
      this.stopLoop = false;
      this.mouseStopped();
    }
    this.mouseX = newMouseX;
    this.mouseY = newMouseY;
  }
  mouseStopped() {
    this.displayFeatureInfo(this.olMap.getEventPixel(this.lastEvt.originalEvent));
  }

  showToolTip(tooltip: any, formFieldContainer: any, labelContainer: any) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: any) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
